<button style="border-radius: 8px;" [copyToClipboard]="copyUrl" class="option-button btn p-0 ml-1">
    <mat-icon class="icon m-1" [svgIcon]="'share2-icon'"></mat-icon>
</button>